// This helps preparing the marketing site of BND to correctly render modals.
// Removing zIndex an position values will remove some stacking contexts, which will help correctly display the modal
export const prepareHostSite = () => {
    const fullWidthElements = document.getElementsByClassName('full_width') as HTMLCollectionOf<HTMLElement>;
    const containerElements = document.getElementsByClassName('container') as HTMLCollectionOf<HTMLElement>;
    const contentElements = document.getElementsByClassName('content') as HTMLCollectionOf<HTMLElement>;
    const sectionInnerElements = document.getElementsByClassName('section_inner') as HTMLCollectionOf<HTMLElement>;

    for (var i = 0; i < fullWidthElements.length; i++) {
        fullWidthElements[i].style.zIndex = 'auto';
        fullWidthElements[i].style.position = 'static';
    }

    for (var j = 0; j < containerElements.length; j++) {
        containerElements[j].style.zIndex = 'auto';
        containerElements[j].style.position = 'static';
    }

    for (var k = 0; k < contentElements.length; k++) {
        contentElements[k].style.zIndex = 'auto';
        contentElements[k].style.position = 'static';
    }

    for (var l = 0; l < sectionInnerElements.length; l++) {
        sectionInnerElements[l].style.zIndex = 'auto';
        sectionInnerElements[l].style.position = 'static';
    }
};